import AApplyTextField from './index.vue';

AApplyTextField.install = app => {
  app.component(AApplyTextField.name, AApplyTextField);
};

export default AApplyTextField;
